export default __webpack_public_path__ + "static/media/ursinebrawl1.2e5d9eaf.png";